import * as React from "react";
import {DisplayFeature} from "../../domain";
import classNames = require("classnames");
import datafangstHelpers from "../../../../../utilities";

interface CellState {
}

interface CellProps {
    feature: DisplayFeature;
    hasFocus: boolean;
}


export default class OperationsCell extends React.Component<CellProps, CellState> {

    render() {
        let {feature, hasFocus} = this.props;
        let cellValueClasses = classNames({
            'cell-component': true,
            'cell-focus': hasFocus,
            'disabled': true,
        });

        let humanReadableOperation = datafangstHelpers.operationFromDomain(feature.operation);

        return (
            <div className={cellValueClasses}>
                {humanReadableOperation}
            </div>
        );
    }
}




